<script>
	import { store } from "$lib/utilities/store";

	import LoginForm from "$lib/sections/Admin/LoginForm.svelte";
	import Cases from "$lib/sections/Cases/Cases.svelte";

	export let data;
	export let lang;

	$: uid = $store?.userProfile?.uid;
</script>

{#if !uid}
	<LoginForm {data} {lang} />
{:else}
	<Cases />
{/if}
